import { graphql } from 'gatsby'

// eslint-disable-next-line no-restricted-exports
export { default } from './Archive'

export const query = graphql`
  query ($gte: Date!, $lt: Date!, $limit: Int!, $skip: Int!) {
    allGhostPost(
      sort: { published_at: DESC }
      filter: {
        tags: { elemMatch: { slug: { eq: "blog" } } }
        published_at: { gte: $gte, lt: $lt }
      }
      limit: $limit
      skip: $skip
    ) {
      nodes {
        ...GhostPostFields
      }
    }
    allGhostPostRecent: allGhostPost(sort: { published_at: DESC }, limit: 5) {
      nodes {
        ...GhostPostFields
      }
    }
  }
`
